import { render, staticRenderFns } from "./11-member-profile-extras.vue?vue&type=template&id=3ec9f480&scoped=true"
import script from "./11-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./11-member-profile-extras.vue?vue&type=script&lang=js"
import style0 from "./11-member-profile-extras.vue?vue&type=style&index=0&id=3ec9f480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec9f480",
  null
  
)

export default component.exports